import { Box } from '@mui/material';
import { keyframes } from '@mui/material/styles';
import { BRAND } from '../theme';

const blink = keyframes`
  0%, 80%, 100% { opacity: 0.25; }
  40% { opacity: 1; }
`;

export function TypingIndicator() {
  return (
    <Box role="status" aria-label="Loom is typing" data-testid="chat-typing" sx={{ display: 'inline-flex', gap: 0.5, px: 1.5, py: 1.25, mb: 1.5, borderRadius: 2, bgcolor: '#f1f4f8', border: `1px solid ${BRAND.line}` }}>
      {[0, 1, 2].map((i) => (
        <Box key={i} sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: BRAND.muted, animation: `${blink} 1.2s ${i * 0.2}s infinite ease-in-out` }} />
      ))}
    </Box>
  );
}
